import { useState } from 'react';
import HeroSection from './components/HeroSection';
import BookingCard from './components/BookingCard';
import RoomList from './components/RoomList';
import HotelInfo from './components/HotelInfo';
import Reviews from './components/Reviews';
import Location from './components/Location';
import QRCodeSection from './components/QRCodeSection';
import { hotelData } from '../../mocks/hotelData';

export default function HotelDetailPage() {
  const [checkInDate, setCheckInDate] = useState('2026-02-20');
  const [checkOutDate, setCheckOutDate] = useState('2026-02-21');
  const [guests, setGuests] = useState(2);
  const [rooms, setRooms] = useState(1);

  return (
    <div className="min-h-screen bg-white">
      <HeroSection images={hotelData.images} />
      
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <div className="mb-6">
              <h1 className="text-3xl font-bold text-gray-900 mb-2">{hotelData.name}</h1>
              <div className="flex items-center gap-4 mb-3">
                <div className="flex items-center gap-2">
                  <div className="bg-teal-600 text-white px-3 py-1 rounded-lg font-bold text-sm">
                    {hotelData.rating}
                  </div>
                  <span className="text-sm text-gray-600">매우 좋음</span>
                  <span className="text-sm text-gray-500">({hotelData.reviewCount}개 이용 후기)</span>
                </div>
              </div>
              <p className="text-sm text-gray-600 flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                {hotelData.location}
              </p>
            </div>

            <RoomList 
              checkInDate={checkInDate}
              checkOutDate={checkOutDate}
              guests={guests}
              rooms={rooms}
            />
            
            <HotelInfo />
            
            <Reviews />
            
            <Location />
            
            <QRCodeSection />
          </div>

          <div className="lg:col-span-1">
            <div className="sticky top-4">
              <BookingCard
                checkInDate={checkInDate}
                checkOutDate={checkOutDate}
                guests={guests}
                rooms={rooms}
                onCheckInChange={setCheckInDate}
                onCheckOutChange={setCheckOutDate}
                onGuestsChange={setGuests}
                onRoomsChange={setRooms}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}